import { ReactElement } from 'react'
import { ProjectBackgroundInformation } from 'src/screens/shared/project/details/background-information/ProjectBackgroundInformation'

export const PfKapBackgroundInformationPage = (): ReactElement => {
  return <ProjectBackgroundInformation baseUrl="/pf-kap" />
}
